export enum CONTACT {
  ADDRESS = 'Unit B3.7, tầng 3, Block B, Chung cư Jamona Heights, 210 Bùi Văn Ba, Phường Tân Thuận Đông, quận 7, thành phố Hồ Chí Minh.',
  FACEBOOK = 'https://www.facebook.com/Vietstats',
  YOUTUBE = 'https://www.youtube.com/@VietstatsCorp',
  LINKEDIN = 'https://www.linkedin.com/company/Vietstats/',
  TWITTER = 'twitter.com',
  EMAIL = 'contact@Vietstats.vn',
  PHONE = '0338922229',
  EMAIL_SUPPORT = 'support@Vietstats.vn',
}

export enum SCREEN {
  DEFAULT = 'default',
  HOME = 'home',
  INDICATOR = 'indicator',
  INDUSTRY = 'indicators',
  LOCAL = 'indicator_local',
  DETAIL = 'detail_indicator',
}

export enum INDICATOR_TAG_SLUGS {
  CS_CHINH = 'cac-chi-so-chinh',
  TCTT = 'tai-chinh-tien-te',
  TKNC = 'tai-khoa-va-no-cong',
  GCLP = 'gia-ca-lam-phat',
  LDVL = 'lao-dong-viec-lam',
  DTFDI = 'dau-tu-fdi',
  DN = 'doanh-nghiep',
  CCVL = 'can-can-vang-lai',
  CCVVTC = 'can-can-von-va-tai-chinh',
  KTTN = 'kinh-te-tu-nhan',
  DNNN = 'doanh-nghiep-nha-nuoc',
  KTS = 'kinh-te-so',
  KTXTH = 'kinh-te-xanh-tuan-hoan',
  TKQT = 'thong-ke-quoc-te',
  TKXH = 'thong-ke-xa-hoi',
  TKHTK = 'thong-ke-tong-hop-khac',
  NAV_INDICATOR_HEADER = 'du-lieu-kinh-te-header',
}

export enum INDUSTRY_TAG_SLUGS {
  CBKTNTH = 'chi-bao-kinh-te-nganh-tong-hop',
  NN = 'nong-nghiep',
  CN = 'cong-nghiep',
  XD = 'xay-dung',
  TMDV = 'thuong-mai-dich-vu',
  TCNH = 'tai-chinh-ngan-hang',
  BDS = 'bat-dong-san',
  CK = 'chung-khoan',
  BH = 'bao-hiem',
}

export enum LOCAL_TAG_SLUGS {
  CNKTDP = 'cap-nhat-kinh-te-dia-phuong',
  KTDPTH = 'kinh-te-dia-phuong-tong-hop',
  KTTT = 'kinh-te-tinh-thanh',
  KTV = 'kinh-te-vung',
}

export const CHART_HEIGHT = '540px';

export const WEB_URL = 'http://beta.Vietstats.vn';

export const FOOTER_RESOURCES = [
  'Excel Add-in',
  'Google Sheets Add-On',
  'API',
  'SDK',
  'R Library',
];

export const FOOTER_CAREER = [
  'Nhà phát triển web',
  'Nhà thiết kế web',
  'Nhà phân tích dữ liệu',
  'Nhà phát triển kinh doanh',
];
